export const companyData = [
  {
    title: "About us",
    to: "about"
  },
  {
    title: "The Academy",
    to: "academy"
  },
  {
    title: "Membership",
    to: "membership"
  },
  {
    title: "FAQs",
    to: "faqs"
  },
];

export const resourceData = [
  {
    title: "Videos",
    to: "videos"
  },
  {
    title: "Community",
    to: "Community"
  },
  {
    title: "Help center",
    to: "/help_center"
  },
  {
    title: "Blog",
    to: "/blog"
  },
];
